/**
 * Side Content position options.
 * @public
 */
enum SideContentPosition {
	/**
	 * The side content is on the right side of the main container
	 * in left-to-right mode and on the left side in right-to-left mode.
	 * @public
	 */
	End = "End",

	/**
	 * The side content is on the left side of the main container
	 * in left-to-right mode and on the right side in right-to-left mode.
	 * @public
	 */
	Start = "Start",
}

export default SideContentPosition;
